// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"styles_sectionWrapper__S5cFf","wrapper":"styles_wrapper__p6ltv","right":"styles_right__GGL7K","left":"styles_left__ncATP"};